import { matchPath } from 'react-router-dom';
import { DASHBOARD_PATHS } from 'consts/paths';

const checkIsDashboardPath = pathname =>
  DASHBOARD_PATHS.some(path => matchPath(pathname, { path, exact: true, strict: false }));

export default checkIsDashboardPath;
